module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n\ntable tr .options {\n  padding: 0px;\n  width: 40px;\n  text-align: center; }\n\ntable tr .options a .fa {\n    color: #e6e6e6; }\n\ntable tr:hover .options a .fa {\n  color: #f55753; }\n\ntable tr .form-group {\n  padding: 0;\n  border: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/forms/elements/components/key-value/key-value.component.scss
// module id = ./libs/chassis-core/src/app/forms/elements/components/key-value/key-value.component.scss
// module chunks = main